export default __webpack_public_path__ + "static/media/language-blue.62423aa5.svg";